import * as React from 'react';

import { Link } from '../link/link';

const s = require('./media_banner.css');

interface IProps {
  url?: string;
  logoImageUrl?: string;
  logoWithoutBackground?: string;
  name?: string;
  actionText?: string;
  phone?: string;
  buttonText?: string;
  info?: string;
  infoText?: string;
  onDidMount?: () => void;
}

export class MediaBanner extends React.Component<IProps> {

  public static defaultProps: IProps = {
    url: '',
    logoImageUrl: '',
    logoWithoutBackground: '0',
    name: '',
    actionText: '',
    phone: '',
    buttonText: 'Узнать цены',
    info: '',
  };

  public componentDidMount() {
    if (this.props.onDidMount) {
      this.props.onDidMount();
    }
  }

  public render() {
    const props = this.props;

    if (!this.props.logoImageUrl) {
      return (<div />);
    } else {
      return (
        <div className={s['c-filters-brand']}>
          <div className={s['c-filters-brand-info']}>
            <a className={s['c-filters-brand-flag']}
               href={props.url}
               target="_blank"
               role="img"
               rel="noopener noreferrer"
               dangerouslySetInnerHTML={{ __html: props.actionText as string }} />
            <a
                className={
                  (this.props.logoWithoutBackground === '1') ?
                    s['c-filters-brand-logo'] :
                    s['c-filters-brand-logo-bg']}
                href={props.url}
                rel="noopener noreferrer"
                role="img"
                target="_blank">
              <img src={props.logoImageUrl} alt="logo" />
            </a>
            <div className={s['c-filters-brand-left']}>
              <a className={s['c-filters-brand-link']}
                 href={props.url}
                 rel="noopener noreferrer"
                 role="button"
                 target="_blank">
                <h3 className={s['c-filters-brand-title']}
                  dangerouslySetInnerHTML={{ __html: props.name as string }} />
                <p className={s['c-filters-brand-text']}
                  dangerouslySetInnerHTML={{ __html: (props.infoText || props.info) as string }} />
              </a>
              <div className={s['c-filters-brand-prices']}>
                <Link
                    href={props.url}
                    className={s['c-filters-brand-button']}
                    rel="noopener noreferrer"
                    target="_blank">
                  {props.buttonText}
                </Link>
                <span className={s['c-filters-brand-tel']}
                  dangerouslySetInnerHTML={{ __html: props.phone as string }} />
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}
